// extracted by mini-css-extract-plugin
module.exports = {"foo":"nwea-ds-v1-template-foo","bar":"nwea-ds-v1-template-bar","blah":"nwea-ds-v1-template-blah"};